import { ReferencePickerType } from '@celito.clients/enums';
import { Filter } from '@celito.clients/types';

import {
  ISimplifedFilter,
  RulesComponentListViewFilter,
} from '../../rules-component/types/rules-component.types';
import { IOption } from '../in-house-input-select.model';

export const convertCustomFilter = (
  filters?: RulesComponentListViewFilter | undefined,
  defaultReferenceFilter?: Filter[] | RulesComponentListViewFilter[],
  customSearch?: RulesComponentListViewFilter
): RulesComponentListViewFilter[] => {
  if (
    !filters?.conditions &&
    !defaultReferenceFilter &&
    !customSearch?.conditions
  )
    return [];

  // Create a new object to avoid modifying the original filters
  const newFilters: any = { conditions: { all: [] } };

  if (filters && filters.conditions)
    newFilters.conditions.all.push(filters.conditions);

  if (defaultReferenceFilter && defaultReferenceFilter.length > 0) {
    // Create a new array and push defaultReferenceFilter into it
    const tempDefaultReferenceFilter =
      defaultReferenceFilter as RulesComponentListViewFilter[];

    if (tempDefaultReferenceFilter?.[0]?.conditions)
      newFilters.conditions.all.push(
        tempDefaultReferenceFilter?.[0]?.conditions
      );
    else
      newFilters.conditions.all.push({
        all: [
          {
            all: defaultReferenceFilter as ISimplifedFilter[],
          },
        ],
      });
  }

  if (customSearch) {
    newFilters.conditions.all.push(customSearch.conditions);
  }

  if (newFilters.conditions.all.length === 0) {
    return [];
  }

  return [newFilters];
};

export const removeDuplicates = (options: IOption[]): IOption[] => {
  const duplicateTracker = new Set<string>();
  const uniqueOptions: IOption[] = [];

  options.forEach((option) => {
    // Create a unique key based on value and text
    const key = `${option.value}|${option.text}`;

    if (!duplicateTracker.has(key)) {
      uniqueOptions.push(option);
      duplicateTracker.add(key);
    }
  });

  return uniqueOptions;
};

export const getText = (
  label?: string,
  title?: string,
  pickerType?: ReferencePickerType
) => {
  if (pickerType === ReferencePickerType.LABEL_TITLE && title && label) {
    return `${label} (${title})`;
  } else if (
    pickerType === ReferencePickerType.TITLE ||
    pickerType === ReferencePickerType.TITLE__S
  ) {
    return title ?? label;
  } else if (pickerType === ReferencePickerType.LABEL_OR_TITLE) {
    return `${label} (${title})`;
  } else {
    return label ?? title;
  }
};

export const getRecordNameFromUrl = (path: string) => {
  // Extract pathname without query parameters

  // Get all segments and take the last one
  const pathSegments = path.split('/').filter((segment) => segment.length > 0);
  return pathSegments[pathSegments.length - 1]; // Last segment before `?`
};
